// DS6.10 for gallections
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiGallection } from '@wix/da-papi-types';
import ImageIcon from '@wix/da-ds/pkg/Icons/24x24/Image';
import DeviantsIcon from '@wix/da-ds/pkg/Icons/24x24/AllDeviants';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from './FolderStats.scss';

interface Props {
  folder: PapiGallection;
  showCountsWithoutCaptions?: boolean;
  withSubscribersCount?: boolean;
}

const FolderStats: React.FC<Props> = ({
  folder,
  showCountsWithoutCaptions,
  withSubscribersCount = true,
}) => {
  const isMobile = useContext(MobileContext);
  const hasNewFolderFeature = useFlag('folders_layout');
  const { t } = useTranslation();

  const folderSize = folder.totalItemCount ?? folder.size ?? 0;
  const subscribersCount = folder.premiumFolderData?.numSubscribers ?? 0;

  if (hasNewFolderFeature && isMobile) {
    return <div className={s['mobile']}>{folderSize}</div>;
  }

  return (
    <div className={s['root']}>
      <div className={s['stat']}>
        {!hasNewFolderFeature && (
          <ImageIcon size={IconSize.SMALLER} disableDefaultColors />
        )}
        <span className={s['label']}>
          {showCountsWithoutCaptions
            ? folderSize
            : t('folderCard.stats.artworks', {
                count: folderSize,
              })}
        </span>
      </div>
      {withSubscribersCount && !!subscribersCount && (
        <div className={s['stat']}>
          {!hasNewFolderFeature && (
            <DeviantsIcon size={IconSize.SMALLER} disableDefaultColors />
          )}
          <span className={s['label']}>
            {showCountsWithoutCaptions
              ? subscribersCount
              : t('folderCard.stats.subscribers', {
                  count: subscribersCount,
                })}
          </span>
        </div>
      )}
    </div>
  );
};
FolderStats.displayName = 'FolderStats';

export default FolderStats;
